import React, { useMemo } from 'react';
import { Range } from 'react-range';
import useLocalization from '../../hooks/useLocalization';

const RangeInput = ({ value = null, step = 1, onChange, min = 0, max = 100, maxWidth = 270, disabled = false }) => {
  const { isRTL } = useLocalization();
  const internalValue = useMemo(() => {
    let v = value < min ? min : value;
    return [v];
  }, [value, min]);

  return (
    <div className="px-2 py-1" style={{ width: maxWidth }}>
      {' '}
      <Range
        label=""
        step={step}
        min={min}
        max={max}
        renderMark={({ props, index }) => {
          const totalSteps = Math.floor((max - min) / step);
          const rtlIndex = isRTL ? totalSteps - index : index;

          return (
            <div
              {...props}
              key={props.key}
              style={{
                ...props.style,
                height: '20px',
                width: '20px',
                borderRadius: '50%',
                backgroundColor: '#e5e9f0'
              }}
              className="d-flex border border-light text-dark align-items-center justify-content-center fw-bold tiny"
            >
              {rtlIndex + 1}
            </div>
          );
        }}
        values={internalValue}
        onChange={values => {
          onChange(values[0]);
        }}
        renderTrack={({ props, children }) => (
          <div
            {...props}
            style={{
              ...props.style,
              height: '10px',
              width: '100%',
              backgroundColor: '#e5e9f0'
            }}
            className="rounded"
          >
            {children}
          </div>
        )}
        renderThumb={({ props }) => {
          return (
            <div
              {...props}
              key={props.key}
              onClick={() => {
                if (disabled) return;
                if (!value) {
                  onChange(props['aria-valuenow']);
                } else {
                  onChange(null);
                }

              }}
              style={{
                ...props.style,
                height: '20px',
                width: '20px',
                borderRadius: '50%',
                backgroundColor: !value ? '#e5e9f0' : '#0c1b33',
                cursor: 'pointer'
              }}
              className={`d-flex align-items-center justify-content-center fw-bold ${!value ? 'border border-light text-dark tiny' : 'text-white smallFont'
                }`}
            >
              {Number(props['aria-valuenow']) || ''}
            </div>
          );
        }}
        rtl={isRTL}
        disabled={disabled}
      />
    </div>
  );
};

export default RangeInput;
